/**
 * 互动层消息通信器抽象类
 */
import { EventEmitter } from 'events';
import { ChannelMessage, ChannelNameSpace, CompsNameSpace } from './ChannelMessage';
import { methodTracker, trackerEnv } from '@iv/shared/src/tracker';

export default abstract class ChildBridge {
  private message: EventEmitter;
  private listened: { [key: string]: boolean };
  private msgHandle: (...args: any[]) => void;

  public constructor() {
    this.message = new EventEmitter();
    this.message.setMaxListeners(0);
    this.listened = {};
    this.bindWaiting();
  }

  public invoke(param: ChannelMessage) {
    const { ns, method, seq } = param;
    this.onPostMessage(param);
    return new Promise((resolve) => {
      this.message.once(`${ns}.${method}.${seq}`, resolve);
    });
  }

  public listen(ns: ChannelNameSpace | CompsNameSpace, event: string, cb: (...args: any[]) => void) {
    const messageEventName = `${ns}>${event}`;
    // 底层只需要监听一次，互动层有消息队列处理
    if (!this.checkListen(ns, event)) {
      this.listened[messageEventName] = true;
      this.invoke({
        nodeId: '',
        ns,
        method: 'on',
        data: { event },
      });
    }
    this.message.on(messageEventName, cb);
  }

  public checkListen(ns: string, event: string) {
    const messageEventName = `${ns}>${event}`;
    return this.listened[messageEventName];
  }

  public destroy() {
    this.onRemoveListener(this.msgHandle);
  }

  @methodTracker(false, trackerEnv.child)
  private bindWaiting() {
    this.msgHandle = ({ data }: { data: any }) => {
      if (!data || !data.ns || !data.method) {
        // 其他业务的message
        return;
      }
      const { ns, method, data: param, seq, type } = data;
      if (seq) {
        // invoke产生的回调
        if (type && type === 'reject') {
          this.message.emit(`${ns}.${method}.${seq}`, Promise.reject(param));
          return;
        }

        this.message.emit(`${ns}.${method}.${seq}`, param);
      } else {
        // listen事件产生的回调
        this.message.emit(`${ns}>${method}`, param);
      }
    };
    this.onAddListener(this.msgHandle);
  }

  protected abstract onPostMessage(param: ChannelMessage): void;
  protected abstract onRemoveListener(cb: (...args: any[]) => void): void;
  protected abstract onAddListener(cb: (...args: any[]) => void): void;
}
